import { AppBar, Grid, Tab, Tabs } from '@material-ui/core';
import React, { useState } from 'react';
import Appointment from '../appointment';
import AppointmentLight from '../appointment-light';

function CreateAppointmentByAssistant() {
  const [numberTab, setNumberTab] = useState(0);

  const handleChangeTab = (_, newValue) => {
    setNumberTab(newValue);
  };

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
        // style={{
        //   display: value === index ? 'flex' : 'none',
        //   flex: '1',
        //   padding: '30px 5px 15px 5px',
        // }}
      >
        {value === index && (
          <Grid container direction="column">
            {children}
          </Grid>
        )}
      </div>
    );
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };

  return (
    <>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <AppBar
          position="static"
          style={{ width: '45%', background: 'white', boxShadow: 'none' }}
        >
          <Tabs
            value={numberTab}
            onChange={handleChangeTab}
            indicatorColor="primary"
            // TabIndicatorProps={{
            //   style: { background: 'white', height: '0px' },
            // }}
            textColor="primary"
            aria-label="simple tabs example"
            variant="fullWidth"
            // style={{
            //   width: '98%',
            // }}
            centered
          >
            <Tab
              // className={`${classes.indicatorTab} ${
              //   numberTab === 0 && classes.activeTab
              // }`}
              label="Paciente no registrado"
              {...a11yProps(0)}
            />
            <Tab
              // className={`${classes.indicatorTab} ${
              //   numberTab === 1 && classes.activeTab
              // }`}
              label="Paciente registrado"
              {...a11yProps(1)}
            />
          </Tabs>
        </AppBar>
        <TabPanel value={numberTab} index={0}>
          <AppointmentLight />
        </TabPanel>
        <TabPanel value={numberTab} index={1}>
          <Appointment />
        </TabPanel>
      </Grid>
    </>
  );
}

export default CreateAppointmentByAssistant;
